module.exports = {
    methods: {
        exists(value) {
            if (value === undefined) {
                return false;
            }

            return true;
        },
        formatGoogleId(id) {
            if (id.length < 9) {
                return id;
            }
            id = id.replace(/\D[^\.]/g, "");
            id = id.slice(0,3) + "-" + id.slice(3, 6) + "-" + id.slice(6);
            return id;
        },
    },
}
